const cardItems = [
  {
    id: 1,
    tag: '4K修复',
    title: '教父三部曲 4K修复版',
    desc: '影史不朽经典，马龙·白兰度与阿尔·帕西诺的传奇演绎，全新4K修复画质，重温黑帮史诗。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20mafia%20movie%20tribute%20with%20vintage%201970s%20aesthetic%2C%20warm%20sepia%20tones%2C%20classic%20film%20noir%20lighting%2C%20Italian%20restaurant%20interior%20with%20dim%20atmospheric%20light%2C%20rich%20dark%20wood%20textures%2C%20professional%20film%20color%20grading%2C%20elegant%20composition%2C%20no%20text%20or%20people&width=800&height=500&seq=card-1-momo&orientation=landscape',
  },
  {
    id: 2,
    tag: '华语经典',
    title: '无间道系列全集',
    desc: '香港警匪片巅峰之作，刘德华梁朝伟巅峰对决，三部连看体验完整无间世界。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20Hong%20Kong%20noir%20style%20with%20rooftop%20silhouette%20against%20dramatic%20sky%2C%20urban%20cityscape%20in%20background%2C%20moody%20atmospheric%20lighting%2C%20film%20noir%20aesthetic%20with%20warm%20and%20cool%20tone%20contrast%2C%20professional%20cinematography%20style%2C%20no%20visible%20text%20or%20faces&width=800&height=500&seq=card-2-momo&orientation=landscape',
  },
  {
    id: 3,
    tag: '动画神作',
    title: '千与千寻 日语原声版',
    desc: '宫崎骏不朽名作，奥斯卡最佳动画长片，奇幻世界中关于成长与勇气的永恒寓言。',
    img: 'https://readdy.ai/api/search-image?query=Anime%20film%20inspired%20fantasy%20scene%20with%20traditional%20Japanese%20bathhouse%20architecture%2C%20warm%20lantern%20lighting%2C%20magical%20atmosphere%2C%20soft%20dreamlike%20colors%2C%20Studio%20Ghibli%20aesthetic%2C%20spirited%20and%20whimsical%20composition%2C%20no%20text%20or%20characters&width=800&height=500&seq=card-3-momo&orientation=landscape',
  },
  {
    id: 4,
    tag: '科幻史诗',
    title: '星际穿越 IMAX版',
    desc: '诺兰科幻神作，黑洞穿越与时间膨胀的震撼视觉，汉斯·季默配乐加持下的宇宙诗篇。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20space%20exploration%20scene%20with%20wormhole%20visual%20effect%2C%20deep%20cosmic%20background%20with%20stars%20and%20nebula%2C%20dramatic%20sci-fi%20lighting%2C%20epic%20scale%20composition%2C%20professional%20film%20color%20grading%20with%20deep%20blacks%20and%20warm%20highlights%2C%20no%20text&width=800&height=500&seq=card-4-momo&orientation=landscape',
  },
  {
    id: 5,
    tag: '年度黑马',
    title: '毒舌律师 粤语原声',
    desc: '年度口碑炸裂的香港律政片，黄子华封神演技，法庭上的唇枪舌剑引爆全场。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20courtroom%20drama%20scene%20with%20dramatic%20lighting%2C%20wooden%20interior%20of%20grand%20courtroom%2C%20warm%20sunlight%20streaming%20through%20tall%20windows%2C%20atmospheric%20dust%20particles%20in%20light%20beam%2C%20professional%20film%20aesthetic%2C%20solemn%20and%20powerful%20mood%2C%20no%20text%20or%20people&width=800&height=500&seq=card-5-momo&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-sparkling-line mr-1"></i>编辑力荐
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精选推荐</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">本周编辑团队精心挑选的高分好片</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cardItems.map((item) => (
            <div key={item.id} className="group bg-background-100 rounded-xl border border-secondary-200/50 overflow-hidden cursor-pointer hover:border-primary-200 transition-all duration-300">
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-primary-500/90 text-white text-[10px] font-medium">{item.tag}</span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-bold text-foreground-950 mb-1.5 line-clamp-2">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}